import { render, staticRenderFns } from "./ConsentGDPR.vue?vue&type=template&id=79472ff5"
import script from "./ConsentGDPR.vue?vue&type=script&lang=js"
export * from "./ConsentGDPR.vue?vue&type=script&lang=js"
import style0 from "./ConsentGDPR.vue?vue&type=style&index=0&id=79472ff5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports